import {
  Mark,
  mergeAttributes,
} from '@tiptap/core'

export interface InlineNoteOptions {
  HTMLAttributes: Record<string, any>,
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    inlineNote: {
      /**
       * Set a inlineNote mark
       */
      setInlineNote: () => ReturnType,
      /**
       * Toggle a inlineNote mark
       */
      toggleInlineNote: () => ReturnType,
      /**
       * Unset a inlineNote mark
       */
      unsetInlineNote: () => ReturnType,
    }
  }
}

export const starInputRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/
export const starPasteRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))/g
export const underscoreInputRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/
export const underscorePasteRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))/g

export const InlineNote = Mark.create<InlineNoteOptions>({
  name: 'inlineNote',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      //Ensure that the TN CMS page break class is added to the horizontal rule when it is present
      class: {
        default: 'note',
        parseHTML: (element) => element.getAttribute('class'),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'ins',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['ins', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addCommands() {
    return {
      setInlineNote: () => ({ commands }) => {
        return commands.setMark(this.name)
      },
      toggleInlineNote: () => ({ commands }) => {
        return commands.toggleMark(this.name)
      },
      unsetInlineNote: () => ({ commands }) => {
        return commands.unsetMark(this.name)
      },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Enter': () => this.editor.chain().createParagraphNear().unsetInlineNote().focus().run()
    }
  },
})